import { useRef, useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';
import { useTranslations } from 'next-intl';
import { Image } from '@/component/Image';
import { allClearHtml } from '@/utils/html';

export const ReviewItem = ({
  id,
  author,
  text,
  createdAt,
  openModal,
  showMore: showMoreInitial = false,
  registerChild,
  classImport,
}) => {
  const date = format(parseISO(createdAt), 'MMMM yyyy');
  const t = useTranslations();
  const [hasMore, setHasMore] = useState(false);
  const [showMore, setShowMore] = useState(showMoreInitial);
  const ref = useRef();
  const markup = { __html: t.raw(allClearHtml(text)) };
  useEffect(() => {
    setHasMore(ref.current.scrollHeight > ref.current.offsetHeight);
  }, []);
  return (
    <div className={`col-span-1 ${classImport}`} ref={registerChild}>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-11 h-11 rounded-full relative bg-slate-100">
          {author.avatar ? (
            <Image
              className="rounded-full absolute inset-0"
              src={author.avatar}
              alt={author.name}
              title={author.name}
              height={44}
              width={44}
            />
          ) : (
            <span
              className={`rounded-full size-11 inline-flex items-center justify-center bg-slate-800 text-white`}
            >
              {author.name[0]}
            </span>
          )}
        </div>
        <div className="text-slate-700 text-base font-medium">
          {author.name}
        </div>
      </div>
      {date && (
        <div className="text-slate-700 text-sm font-medium mb-1">{date}</div>
      )}
      <div
        ref={ref}
        className={`text-slate-500 text-base leading-normal !mb-3 ${
          showMore ? '' : 'line-clamp-3'
        }`}
        dangerouslySetInnerHTML={markup}
      />
      {openModal && (
        <button
          className="link link-sm link-primary link-bold"
          onClick={() => openModal(id)}
          type="button"
          data-testid="room-review-show-more-button"
        >
          {showMore ? t('hide-more') : t('show-more')}
        </button>
      )}
    </div>
  );
};
